import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { WidgetType } from '../../../shared/domain/widget-type.model';
import { PublisherAdUnitRequest } from '../../../shared/domain/publisher-ad-unit-request.model';
import { Domain, DomainManagement } from '../../../shared/domain/domain.model';
import { BridgeAdUnit } from '../../../shared/domain/bridge-ad-unit.model';
import { Publisher } from '../../../shared/domain/publisher.model';
import { PublisherBidderAdUnitRequest } from '../../products/bidder/publisher-bidder-ad-unit-request.model';
import {SiteApprovalRequest, SiteListResponse} from '../../../shared/domain/site-approval-request.model';
import { HttpUtils } from '../../../shared/utils/http-utils';
import { ConsumableAdstxtRecord } from '../../../shared/domain/consumable-adstxt-record.model';
import {App} from '../../../shared/domain/app.model';
import {AppListResponse} from '../../../shared/domain/app-approval-request.model';

@Injectable()
export class PublisherStatsService {

  constructor(private http: HttpClient) {
  }

  validateWidgetTypeForDomains(id: string, domains: string[]): Observable<string[]> {
    return this.http.get<string[]>(`${environment.serviceUrl}/ad-stats/publisher-products/widget-types/${id}/validate-domains`, {
      params: HttpUtils.getHttpParams({
        domain: domains
      })
    });
  }

  listWidgetTypes(): Observable<WidgetType[]> {
    return this.http.get<WidgetType[]>(`${environment.serviceUrl}/ad-stats/publisher-products/widget-types`);
  }

  productsRequestUnit(widgetTypeId: string, request: PublisherAdUnitRequest) {
    return this.http.post(`${environment.serviceUrl}/ad-stats/publisher-products/${widgetTypeId}/request-unit`, request);
  }

  productsRequestBidderUnit(request: PublisherBidderAdUnitRequest) {
    return this.http.post(`${environment.serviceUrl}/ad-stats/publisher-products/request-bidder-unit`, request);
  }

  productsSummaryDomains(widgetNames: string[]): Observable<Domain[]> {
    return this.http.get<Domain[]>(`${environment.serviceUrl}/ad-stats/publisher-products/summary/domains`, {
      params: {
        widgetName: widgetNames
      }
    });
  }

  productsSummaryApprovedDomains(pubId: string): Observable<Domain[]> {
    return this.http.get<Domain[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/publisher/${pubId}/approved-sites`);
  }



  createPublisherDomains(request: { urls: string[], management: DomainManagement }): Observable<Domain[]> {
    return this.http.post<Domain[]>(`${environment.serviceUrl}/ad-stats/publisher-products/domains`, request);
  }

  createPublisherApps(name: string, bundle: string, storeUrl: string, appAdsTxtDomain: string): Observable<App[]> {
    return this.http.post<App[]>(`${environment.serviceUrl}/ad-stats/publisher-products/apps`, { name: name, bundle: bundle, storeUrl: storeUrl, appAdsTxtDomain: appAdsTxtDomain });
  }

  getPublisherDomains(publisherId: string, includeRonDomain = false): Observable<Domain[]> {
    return this.http.get<Domain[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/publisher/${publisherId}/domains`, {
      params: HttpUtils.getHttpParams({
        includeRonDomain: includeRonDomain
      })
    });
  }

  getPublisherSites(req: SiteApprovalRequest): Observable<SiteListResponse> {
    return this.http.get<SiteListResponse>(`${environment.serviceUrl}/ad-stats/publisher-stats/publisher/${req.publisherId}/sites`, {
      params: HttpUtils.getHttpParams(req)
    });
  }

  updatePublisher(publisher: Publisher): Observable<Publisher> {
    return this.http.put<Publisher>(`${environment.serviceUrl}/ad-stats/publisher-stats/publisher/${publisher.id}`, publisher);
  }

  uploadW8(pubId: string, file: File): Observable<Publisher> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<Publisher>(`${environment.serviceUrl}/ad-stats/adu/publisher/w8/${pubId}`, formData);
  }

  deleteDomain(pubId: string, domain: Domain) {
    return this.http.delete(`${environment.serviceUrl}/ad-stats/publisher-stats/publisher/${pubId}/sites/${domain.id}`);
  }

  deleteApp(pubId: string, app: App) {
    return this.http.delete(`${environment.serviceUrl}/ad-stats/publisher-stats/publisher/${pubId}/sites/${app.id}`);
  }
  getBlockedDomains(pubId: string): Observable<string[]> {
    return this.http.get<string[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/publisher/${pubId}/blocked-domains`);
  }

  publisherAdsTxtRecords(type: string): Observable<ConsumableAdstxtRecord[]> {
    return this.http.get<ConsumableAdstxtRecord[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/consumable-adstxts?type=${type}`);
  }

  getAdUnits(): Observable<BridgeAdUnit[]> {
    return this.http.get<BridgeAdUnit[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/publisher/ad-units`);
  }
}

export class DomainWidgetValidationResult {
  valid: boolean;
  unitsRunningSameSizeWidgets: BridgeAdUnit[];
  requestsWithSameSizeWidgets: PublisherAdUnitRequest[];
}
